import { ProductFullSolrDTO } from "./product-full-solr";
import { SolrDocsDTO } from './solr-docs';
import { AbstractDTO } from "@signature-it/ngx-generic/models";

export class SolrFullDocsDTO extends SolrDocsDTO {

    _products: Array<ProductFullSolrDTO>;

    constructor(attributes?: object) {
		super(attributes);
    }

    set products(value) {
        this._products = ProductFullSolrDTO.createFromArray(value);;
    }

    get products() {
        return this._products;
    }
}
